/**
 * Dinheiro é sempre representado em **centavos inteiros** dentro do sistema.
 * Reais com ponto flutuante só aparecem na borda: ao falar com o Asaas e ao formatar
 * para a tela ou para o PDF. Isso evita erros de arredondamento em valores de seis dígitos.
 */

/** Centavos de real. Sempre inteiro, sempre >= 0 nas cobranças. */
export type Centavos = number;

export function reaisParaCentavos(reais: number): Centavos {
  return Math.round(reais * 100);
}

export function centavosParaReais(centavos: Centavos): number {
  return centavos / 100;
}

/**
 * Aplica um percentual sobre um valor em centavos, arredondando para o centavo mais próximo.
 * `percentual` é expresso em pontos percentuais (5 = 5%).
 */
export function percentualDe(centavos: Centavos, percentual: number): Centavos {
  return Math.round((centavos * percentual) / 100);
}

const FORMATADOR_BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** "R$ 120.000,00" */
export function formatarBRL(centavos: Centavos): string {
  return FORMATADOR_BRL.format(centavosParaReais(centavos));
}

const FORMATADOR_BRL_CURTO = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/** "R$ 120.000" — usado nos KPIs e cartões do painel, onde os centavos são ruído. */
export function formatarBRLCurto(centavos: Centavos): string {
  return FORMATADOR_BRL_CURTO.format(centavosParaReais(centavos));
}
